import React, { Component, Fragment } from "react";
import { Button, Container, Image } from "react-bootstrap";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import arrowLeft from "../../../../../assets/images/arrow-left.svg";
import dollar from "../../../../../assets/images/icon-dollar-small.svg";
import Spinner from "../../../../../components/UI/Spinner/Spinner";
import { logFirebaseEvent } from "../../../../../shared/utility";
import * as actions from "../../../../../store/actions/index.js";

interface IParentProps {
  claimId: number;
  procedureLabel: string;
  patientName: string;
  onBackClick: () => void;
}
interface IStateFromProps {
  loadingClaimStatus: boolean;
  errorClaimStatus: boolean;
  errorMessageClaimStatus: string;
  balanceBillingClaimStatus: {
    step: number;
    subSteps: {
      id: number;
      subStep: string;
      tip: string[];
      progress: string;
    }[];
  };
  t: any;
}
interface IDispatchFromProps {
  onFetchBalanceBillingClaimStatus: (claimId: number) => void;
}
type Props = IParentProps &
  IStateFromProps &
  IDispatchFromProps &
  RouteComponentProps;

class MyBillProgress extends Component<Props> {
  componentDidMount() {
    logFirebaseEvent("ClaimStatus");
    this.props.onFetchBalanceBillingClaimStatus(this.props.claimId);
    // this.props.onFetchBalanceBillingClaimStatus(2235);
  }
  loadingClaimStatus = () => {
    if (this.props.loadingClaimStatus) {
      return <Spinner />;
    }
  };

  render() {
    const { t } = this.props;
    const { procedureLabel, patientName, onBackClick } = {
      ...this.props,
    };

    console.log(
      "this.props.balanceBillingClaimStatus.step",
      this.props.balanceBillingClaimStatus.step
    );
    let steps: any;
    if (this.props.balanceBillingClaimStatus.step !== 0) {
      console.log("step to check", this.props.balanceBillingClaimStatus.step);
      if (this.props.balanceBillingClaimStatus.step === 1) {
        console.log("inside 1", this.props.balanceBillingClaimStatus.step);
        steps = (
          <div className="processing">
            <div className="process-steps">
              <span>
                <label>1</label>
              </span>
              {/* <strong>Dispute Process Step X</strong> */}
            </div>
            <div className="process-current">
              <span>
                <label>{+this.props.balanceBillingClaimStatus.step + 1}</label>
              </span>
            </div>
            <div className="process active"></div>
            <div className="process"></div>
            <div className="process"></div>
            <div className="process"></div>
            <div className="process"></div>
          </div>
        );
      } else if (this.props.balanceBillingClaimStatus.step === 2) {
        console.log("inside 2", this.props.balanceBillingClaimStatus.step);
        steps = (
          <div className="processing">
            <div className="process-steps">
              <span className="active">
                <label>1</label>
              </span>
              <span>
                <label>2</label>
              </span>
              {/* <strong>Dispute Process Step X</strong> */}
            </div>
            <div className="process-current">
              <span>
                <label>{+this.props.balanceBillingClaimStatus.step + 1}</label>
              </span>
            </div>
            <div className="process active"></div>
            <div className="process active"></div>
            <div className="process"></div>
            <div className="process"></div>
            <div className="process"></div>
          </div>
        );
      } else if (this.props.balanceBillingClaimStatus.step === 3) {
        console.log("inside 3", this.props.balanceBillingClaimStatus.step);
        console.log("step to check", this.props.balanceBillingClaimStatus.step);
        steps = (
          <div className="processing">
            <div className="process-steps">
              <span className="active">
                <label>1</label>
              </span>
              <span className="active">
                <label>2</label>
              </span>
              <span>
                <label>3</label>
              </span>
              {/* <strong>Dispute Process Step X</strong> */}
            </div>
            <div className="process-current">
              <span>
                <label>{+this.props.balanceBillingClaimStatus.step + 1}</label>
              </span>
            </div>
            <div className="process active"></div>
            <div className="process active"></div>
            <div className="process active"></div>
            <div className="process"></div>
            <div className="process"></div>
          </div>
        );
      } else if (this.props.balanceBillingClaimStatus.step === 4) {
        console.log("inside 4", this.props.balanceBillingClaimStatus.step);
        steps = (
          <div className="processing">
            <div className="process-steps">
              <span className="active">
                <label>1</label>
              </span>
              <span className="active">
                <label>2</label>
              </span>
              <span className="active">
                <label>3</label>
              </span>
              <span>
                <label>4</label>
              </span>
              {/* <strong>Dispute Process Step X</strong> */}
            </div>
            <div className="process-current">
              <span>
                <label>{+this.props.balanceBillingClaimStatus.step + 1}</label>
              </span>
            </div>
            <div className="process active"></div>
            <div className="process active"></div>
            <div className="process active"></div>
            <div className="process active"></div>
            <div className="process"></div>
          </div>
        );
      } else if (this.props.balanceBillingClaimStatus.step === 5) {
        console.log("inside 5", this.props.balanceBillingClaimStatus.step);
        steps = (
          <div className="processing">
            <div className="process-steps">
              <span className="active">
                <label>1</label>
              </span>
              <span className="active">
                <label>2</label>
              </span>
              <span className="active">
                <label>3</label>
              </span>
              <span className="active">
                <label>4</label>
              </span>
              <span>
                <label>5</label>
              </span>
              {/* <strong>Dispute Process Step X</strong> */}
            </div>
            <div className="process-current">
              <span>
                <label>{+this.props.balanceBillingClaimStatus.step + 1}</label>
              </span>
            </div>
            <div className="process active"></div>
            <div className="process active"></div>
            <div className="process active"></div>
            <div className="process active"></div>
            <div className="process active"></div>
          </div>
        );
      }
    }
    let timeline: any;
    if (
      this.props.balanceBillingClaimStatus.step !== 0 &&
      this.props.balanceBillingClaimStatus.subSteps.length > 0
    )
      timeline = (
        <ul className="timeline">
          {this.props.balanceBillingClaimStatus.subSteps.map((subStep) => {
            if (
              subStep.progress.toLowerCase().match(/completed/g) ||
              subStep.progress.toLowerCase().match(/closed/g)
            ) {
              console.log("substep in ", subStep.progress);
              return (
                <li className="active">
                  <p>
                    <strong>{subStep.subStep}</strong>
                    {subStep.tip.map((tip) => (
                      <span className="tip">
                        {tip}
                        <br />
                      </span>
                    ))}
                  </p>
                </li>
              );
            } else if (
              subStep.progress.toLowerCase().match(/current/g) ||
              subStep.progress.toLowerCase().match(/in progress/g)
            ) {
              console.log("substep in ", subStep.progress);
              return (
                <li className="selected">
                  <p>
                    <strong>{subStep.subStep}</strong>
                    {subStep.tip.map((tip) => (
                      <span>
                        {tip}
                        <br />
                      </span>
                    ))}
                  </p>
                </li>
              );
            } else {
              console.log("substep in ", subStep.progress);
              return (
                <li>
                  <p>
                    <strong>{subStep.subStep}</strong>
                    {subStep.tip.map((tip) => (
                      <span>
                        {tip}
                        <br />
                      </span>
                    ))}
                  </p>
                </li>
              );
            }
          })}
        </ul>
      );
    else
      timeline = (
        <div className="no-data">
          <div className="no-data-msg">{t("error.statusNotAvailable")}</div>
        </div>
      );
    return (
      <Fragment>
        <Container fluid>
          {this.loadingClaimStatus()}
          <div className="inner-banner">
            <div className="inner-banner-title">
              <h3>{t("balanceBilling.balanceBilling")}</h3>

              <Image src={dollar} alt="dollar" data-test="stockIMG" />
            </div>
          </div>
          <div className="bills-back-list" onClick={onBackClick}>
            <Button className="btnLink iconLeft">
              <Image src={arrowLeft} alt="arrowLeft" />
              {t("balanceBilling.backBtn")}
            </Button>

            <h6 className="bill-heading">{t("balanceBilling.subTitle")}</h6>
          </div>
          <div className="progress-details">
            <h4>
              {procedureLabel}
              <span>{patientName}</span>
            </h4>
          </div>
          <div className="timeline-section">
            {steps}
            {timeline}
          </div>
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  loadingClaimStatus: state.fetchBalanceBillingClaimStatus.loading,
  errorClaimStatus: state.fetchBalanceBillingClaimStatus.error,
  errorMessageClaimStatus: state.fetchBalanceBillingClaimStatus.errorMessage,
  balanceBillingClaimStatus:
    state.fetchBalanceBillingClaimStatus.balanceBillingClaimStatus,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchBalanceBillingClaimStatus: (claimId) =>
    dispatch(actions.fetchBalanceBillingClaimStatus(claimId)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MyBillProgress));
